import { useCallback } from "react";

import { Button } from "react-bootstrap";
import { Prompt } from "react-router-dom";

import { ServiceOrderType } from "../../../_constants/serviceOrder.ts";
import ModalDwellingExpress from "../../../common/components/ModalDwellingExpress";
import DiagnosticsServiceForm from "../components/DiagnosticsServiceForm";
import ErpExpressServiceForm from "../components/ErpExpressServiceForm";
import IncomingInventoryForm from "../components/IncomingInventoryForm";
import OutgoingIncomingInventoryForm from "../components/OutgoingIncomingInventoryForm";
import OutgoingInventoryForm from "../components/OutgoingInventoryForm";
import { useServiceInventoryStore } from "../store/ServiceInventoryStore";

interface ServiceOrderingContainerProps {
  onBack?: () => void;
}

const ServiceOrderingContainer = ({
  onBack,
}: ServiceOrderingContainerProps = {}) => {
  const {
    currentForm,
    dwelling,
    setShowModalDwellingExpress,
    showModalDwellingExpress,
    setSelectedAddress,
    inventory,
    erpExpress,
    diagnostic,
    resetBusinessType,
  } = useServiceInventoryStore((state) => state);

  // to change form when menu selected or re-render form when dwelling change (like dwelling express)
  const FormComponent = useCallback(() => {
    switch (currentForm) {
      case ServiceOrderType.INCOMING_INVENTORY:
        return <IncomingInventoryForm />;
      case ServiceOrderType.OUTGOING_INVENTORY:
        return <OutgoingInventoryForm />;
      case ServiceOrderType.OUTGOING_INVENTORY_WITH_COSTING:
        return <OutgoingInventoryForm withCosting />;
      case ServiceOrderType.OUTGOING_INCOMING_INVENTORY:
        return <OutgoingIncomingInventoryForm />;
      case ServiceOrderType.ERP_EXPRESS:
        return <ErpExpressServiceForm />;
      case ServiceOrderType.DIAGNOSTIC:
      case ServiceOrderType.PPPT:
      case ServiceOrderType.CONDOMINIUM_VISIT:
      case ServiceOrderType.CONDOMINIUM_CREATION:
      case ServiceOrderType.ENERGY_AUDIT:
        return <DiagnosticsServiceForm diagnosticServiceType={currentForm} />;

      default:
        return <></>;
    }
  }, [currentForm, dwelling]);

  const handleBackClick = () => {
    // Reset businessType when going back
    resetBusinessType();
    if (onBack) {
      onBack();
    }
  };

  return (
    <div className="bg-container serviceOrdering">
      <Prompt
        when={!!(inventory || erpExpress || diagnostic)}
        message={
          "Vous avez une commande dans le panier.\nÊtes vous sur de vouloir quitter?"
        }
      />
      {onBack && (
        <div className="d-flex justify-content-start mb-3">
          <Button
            variant="outline-secondary"
            onClick={handleBackClick}
            className="d-flex align-items-center"
          >
            <i className="bi bi-arrow-left me-2"></i> Retour
          </Button>
        </div>
      )}
      <FormComponent />
      <ModalDwellingExpress
        show={showModalDwellingExpress}
        onHide={() => setShowModalDwellingExpress(false)}
        onSubmit={(dwelling) => setSelectedAddress(dwelling)}
      />
    </div>
  );
};

export default ServiceOrderingContainer;
